import { makeStyles, tokens } from '@fluentui/react-components';
import React from 'react';

const useStyles = makeStyles({
    container: {
        padding: `0 ${tokens.spacingHorizontalL}`,
        height: '100%',
        overflow: 'auto',
    },
});

const Aufnahme: React.FC = () => {
    const styles = useStyles();

    const handleOpenLink = () => {
        // Link to Sharepoint Online Admission area
        window.open('https://imcfhkrems.sharepoint.com/sites/Admission/SitePages/Home.aspx', '_blank');
    };

    return (
        <div className={styles.container}>
            <h1>Aufnahme</h1>
            <p>Zugriff auf den Aufnahmebereich in Sharepoint Online</p>
            <button onClick={handleOpenLink}>Zu Sharepoint - Admission</button>
        </div>
    );
};

export default Aufnahme;
